module.exports = __webpack_public_path__ + "img/Picture8.367c505d.png";